<template>
  <div id="app" class="site-shell">
    <header class="site-header">
      <div class="brand">
        <span class="brand-cn">茂名泓森网络科技有限公司</span>
        <span class="brand-en">Maoming Hongsen Network Technology Co., Ltd.</span>
      </div>
      <nav class="site-nav">
        <router-link to="/" exact>首页</router-link>
        <router-link to="/about">关于我们</router-link>
      </nav>
    </header>
    <main class="site-main">
      <router-view />
    </main>
    <footer class="site-footer">
      <div class="footer-info">
        <span class="footer-name">© 2026 茂名泓森网络科技有限公司 Maoming Hongsen Network Technology Co., Ltd.</span>
        <span class="footer-meta">统一社会信用代码：91440900MAEWCRJP6H</span>
        <span class="footer-meta">地址：茂名市电白区电城镇东街河东巷9号401房</span>
        <span class="footer-meta footer-en">
          Add: Room 401, No.9, Hedong Ln, East St, Diancheng, Dianbai Dist, Maoming City, Guangdong Province
        </span>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
